import { ABP, eLayoutType } from '@abp/ng.core';

export const VIAGEM_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/viagens',
    iconClass: 'fas fa-truck',
    name: 'Visibility',
    layout: eLayoutType.application,
    order: 3,
    requiredPolicy: 'cargo_fleet.Viagens',
  },
];
